import { render } from "./ShaxsiyIshReja.vue?vue&type=template&id=27db3b12&scoped=true"
import script from "./ShaxsiyIshReja.vue?vue&type=script&lang=js"
export * from "./ShaxsiyIshReja.vue?vue&type=script&lang=js"

import "./ShaxsiyIshReja.vue?vue&type=style&index=0&id=27db3b12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27db3b12"]])

export default __exports__